import * as React from 'react'
import Typography from '@material-ui/core/Typography'
import TextField from '@material-ui/core/TextField'
import Input from '@material-ui/core/Input'
import InputLabel from '@material-ui/core/InputLabel'
import FormControl from '@material-ui/core/FormControl'
import Grid from '@material-ui/core/Grid'

import IOrder from '../../models/IOrder'
import IDictionary from '../../models/IDictionary'
import EmailInput from '../shared/EmailInput'
import PhoneInput from '../shared/PhoneInput'
import StateInput from '../shared/StateInput'
import MaskInput from '../shared/MaskInput'

interface IContactProps {
  order: IOrder
  onChange: React.ChangeEventHandler
  onBlur: (e: any) => void
  validateOrder: IDictionary<boolean>
  invalidPhone?: boolean
  invalidEmail?: boolean
}

const Contact: React.SFC<IContactProps> = props => {
  const {
    order,
    onChange,
    onBlur,
    validateOrder,
    invalidPhone,
    invalidEmail
  } = props

  return (
    <>
      <Typography variant="h6" gutterBottom>
        Contact Info
      </Typography>

      <Grid container spacing={16}>
        <Grid item xs={6}>
          <TextField
            required
            error={validateOrder.firstName && order.firstName === ''}
            name="firstName"
            label="First Name"
            fullWidth
            autoComplete="fname"
            value={order.firstName}
            onChange={onChange}
            onBlur={onBlur}
          />
        </Grid>
        <Grid item xs={6}>
          <TextField
            required
            error={validateOrder.lastName && order.lastName === ''}
            name="lastName"
            label="Last Name"
            fullWidth
            autoComplete="lname"
            value={order.lastName}
            onChange={onChange}
            onBlur={onBlur}
          />
        </Grid>
        <Grid item xs={12}>
          <EmailInput
            email={order.email}
            onChange={onChange}
            onBlur={onBlur}
            error={validateOrder.email && (order.email === '' || invalidEmail)}
          />
        </Grid>
        <Grid item xs={12}>
          <PhoneInput
            phone={order.phoneNumber}
            onChange={onChange}
            onBlur={onBlur}
            error={
              validateOrder.phoneNumber &&
              (order.phoneNumber === '' || invalidPhone)
            }
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            required
            error={validateOrder.addressLine1 && order.addressLine1 === ''}
            name="addressLine1"
            label="Address line 1"
            fullWidth
            value={order.addressLine1}
            onChange={onChange}
            onBlur={onBlur}
            autoComplete="billing address-line1"
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            name="addressLine2"
            label="Address line 2"
            fullWidth
            value={order.addressLine2}
            onChange={onChange}
            autoComplete="billing address-line2"
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            required
            error={validateOrder.city && order.city === ''}
            name="city"
            label="City"
            fullWidth
            value={order.city}
            onChange={onChange}
            onBlur={onBlur}
            autoComplete="billing locality"
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <StateInput
            state={order.state}
            onChange={onChange}
            onBlur={onBlur}
            error={validateOrder.state && order.state === ''}
          />
        </Grid>
        <Grid item xs={12} sm={12}>
          <FormControl fullWidth error={validateOrder.zip && order.zip === ''}>
            <InputLabel>Postal code *</InputLabel>
            <Input
              required
              name="zip"
              autoComplete="billing postal-code"
              value={order.zip}
              onChange={onChange}
              onBlur={onBlur}
              inputComponent={MaskInput}
              inputProps={{
                mask: [/\d/, /\d/, /\d/, /\d/, /\d/]
              }}
              fullWidth
            />
          </FormControl>
        </Grid>
      </Grid>
    </>
  )
}

export default Contact



// WEBPACK FOOTER //
// ./src/components/contest/Contact.tsx